import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import {Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn} from 'material-ui/Table';

class List extends Component {
  static propTypes = {
    drivers: PropTypes.array
  }

  render() {
    const { drivers } = this.props;
    const content = drivers.map((item, key) => {
      const { id, name, phone } = item;
      return (<TableRow key={key}>
        <TableRowColumn>{id}</TableRowColumn>
        <TableRowColumn>{name}</TableRowColumn>
        <TableRowColumn>{phone}</TableRowColumn>
      </TableRow>);
    });

    return (
      <div>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHeaderColumn>ID</TableHeaderColumn>
              <TableHeaderColumn>Name</TableHeaderColumn>
              <TableHeaderColumn>Phone</TableHeaderColumn>
            </TableRow>
          </TableHeader>
          <TableBody>
            { content }
          </TableBody>
        </Table>
      </div>
    );
  }
}

export default List;


// WEBPACK FOOTER //
// ./src/components/Drivers/List.js